import { C } from "../styles";
import { SP, RAD } from "../ui";

// Each metric carries a category colour, shown as a small dot beside the label
// (the same dot-as-state language used across the portal). Numbers stay neutral
// (text-1) for maximum contrast/readability; the dot does the colour-coding.
const METRICS = [
  { key: "total",      label: "Total",          tone: C.blue },
  { key: "draft",      label: "Draft",          tone: C.warning },
  { key: "submitted",  label: "Waiting for QA", tone: C.violet },
  { key: "inProgress", label: "In Progress",    tone: "#22d3ee" },
  { key: "approved",   label: "Approved",       tone: C.success },
  { key: "rejected",   label: "Rejected",       tone: C.danger },
];

function MetricsGrid({ stats }) {
  return (
    <div className="metrics-grid" style={{
      display: "grid",
      gridTemplateColumns: "repeat(6, 1fr)",
      gap: SP[3],
      marginBottom: SP[6],
    }}>
      {METRICS.map(({ key, label, tone }) => (
        <div key={key} className="metric-card ui-card" style={{
          background: "var(--card)",
          border: "1px solid var(--border)",
          borderRadius: RAD.lg,
          padding: SP[5],
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: SP[2], marginBottom: SP[3] }}>
            <span aria-hidden="true" style={{ width: "7px", height: "7px", borderRadius: "50%", background: tone, flexShrink: 0 }} />
            <span style={{ fontSize: "11px", fontWeight: 700, color: C.text2, textTransform: "uppercase", letterSpacing: "0.08em", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {label}
            </span>
          </div>
          <div style={{ fontSize: "30px", fontWeight: 700, color: C.text1, letterSpacing: "-0.03em", lineHeight: 1 }}>
            {stats[key] ?? 0}
          </div>
        </div>
      ))}
    </div>
  );
}

export default MetricsGrid;
